export enum ENVIRONMENT_URL {
  Stage = 'stage.respondedu.com',
  Portal = 'portal.respondedu.com',
}

export const SUPPORT_EMAIL = 'support@respondedu.com';

export const WEBSITE_URL = 'https://www.respondedu.com/';

export enum XANO_WORKSPACE_CODE {
  DEV = 'iXRJAGMB',
  STAGE = 'rvW79E8r',
  PROD = 'YhBcHjdZ',
  STAGE_CLONE = '_ufOKOiP',
}

export enum FrontendSiteType {
  PORTAL = 'portal',
  DEV = 'dev',
  STAGE = 'stage',
}
